const peopleDialogEl = document.querySelector(".people .people__dialog");
const dialogCloseEl = peopleDialogEl?.querySelector("button");
const dialogContentEl = peopleDialogEl?.querySelector("div");
const peopleEls = document.querySelectorAll(".people .card--people");

dialogCloseEl?.addEventListener("click", () => {
  peopleDialogEl.close();
});

peopleEls?.forEach((el) => {
  const readMoreEl = el.querySelector("button.read-more");
  readMoreEl?.addEventListener("click", () => {
    if (!dialogContentEl) return null;
    dialogContentEl.innerHTML = el.outerHTML;
    peopleDialogEl.showModal();
  });
});
